// import Questionnare from "./questionnare/Questionnare";

export default class Globals {
    // static onClickSideSubMenu(mi) {
    //     window.setInnerBody(<Questionnare id={mi.props.id} key={'ques_' + mi.id} />);
    // }
}